require('../../modules/es6.math.fround');
module.exports = require('../../modules/_core').Math.fround;



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/math/fround.js
// module id = 1445
// module chunks = 0